import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listBanners } from './../../../api/banner';

const Breadcrumb = ({title,subtitle,img}) => {

  const [bannerInterno, setBannerInterno] = useState(null);
  
  useEffect(function() {
    listBanners().then(function(result) {
      (result && result.forEach(function(item) {
        if (item.localizao == 'interno') {
          setBannerInterno(item.file);
        }
      }));
    });
  }, []);

  return (
    <>
      <section className="page__title-area page__title-height page__title-overlay d-flex align-items-center" 
      style={{background:`url(/assets/img/Capa-03${bannerInterno !== null ? bannerInterno : ''}.png)`,backgroundSize:'cover',
      backgroundPosition:'center',backgroundRepeat:'no-repeat'}}>
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="page__title-wrapper mt-110">
                <h3 className="page__title">{title}</h3>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{subtitle}</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Breadcrumb;